import styled from 'styled-components';

export const HeaderButton = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    gap: 0.75rem;
    height: auto;
    padding: 0.75rem;
    border-radius: 0.75rem;
    background: linear-gradient(
        to bottom right,
        hsl(220 40% 55% / 0.25),
        hsl(220 50% 45% / 0.15),
        hsl(240 45% 40% / 0.25)
    );
    border: 1px solid hsl(220 30% 60% / 0.3);
    box-shadow: 0 4px 12px hsl(220 40% 40% / 0.1);
`;

export const IconContainer = styled.div`
    display: flex;
    height: 2rem;
    width: 2rem;
    align-items: center;
    justify-content: center;
    border-radius: 0.5rem;
    background-color: hsl(220 50% 45%);
    flex-shrink: 0;

    svg {
        height: 1rem;
        width: 1rem;
        color: white;
        flex-shrink: 0;
    }
`;

export const HeaderInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
    flex: 1;
    overflow: hidden;
`;

export const HeaderTitle = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.875rem;
    font-weight: 700;
    color: hsl(var(--sidebar-foreground));
`;

export const HeaderLabel = styled.span`
    font-size: 0.75rem;
    color: hsl(var(--sidebar-foreground) / 0.7);
`;
